import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Lenke from "../../nav-frontend-lenker";
import Alertstripe from "..";
export const _frontmatter = {
  "ingress": "Alertstripen er en komponent som benyttes for å gi brukeren varsler av ymse slag, og komponenten støtter forskjellige visninger basert på hvilken type varsel som formidles til brukeren."
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#default-striper"
          }}>{`Default striper`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#inline-striper"
          }}>{`Inline striper`}</a></li></ol></nav>
    <h2 {...{
      "id": "default-striper"
    }}>{`Default striper`}</h2>
    <Example mdxType="Example">
  <Alertstripe type="info" mdxType="Alertstripe">Nå kan du sende inn søknaden.</Alertstripe>
  <br />
  <Alertstripe type="suksess" mdxType="Alertstripe">Du har sendt søknaden.</Alertstripe>
  <br />
  <Alertstripe type="advarsel" mdxType="Alertstripe">
    Det er mange som bruker nav.no nå, derfor kan det ta litt tid før søknaden
    din kommer fram.
  </Alertstripe>
  <br />
  <Alertstripe type="feil" mdxType="Alertstripe">
    Det er ikke mulig å sende søknaden akkurat nå, vennligst prøv igjen senere.
    Du er velkommen til å <Lenke href="#" mdxType="Lenke">følge med på hvordan det går</Lenke>.
  </Alertstripe>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<Alertstripe type="info">Nå kan du sende inn søknaden.</Alertstripe>
<Alertstripe type="suksess">Du har sendt søknaden.</Alertstripe>
<Alertstripe type="advarsel">
  Det er mange som bruker nav.no nå, derfor kan det ta litt tid før søknaden din
  kommer fram.
</Alertstripe>
<Alertstripe type="feil">
  Det er ikke mulig å sende søknaden akkurat nå, vennligst prøv igjen senere. Du
  er velkommen til å <Lenke href="#">følge med på hvordan det går</Lenke>.
</Alertstripe>
`}</code></pre>
    <h2 {...{
      "id": "inline-striper"
    }}>{`Inline striper`}</h2>
    <Example mdxType="Example">
  <Alertstripe type="info" form="inline" mdxType="Alertstripe">
    Nå kan du sende inn søknaden.
  </Alertstripe>
  <br />
  <Alertstripe type="suksess" form="inline" mdxType="Alertstripe">
    Du har sendt søknaden.
  </Alertstripe>
  <br />
  <Alertstripe type="advarsel" form="inline" mdxType="Alertstripe">
    Det er mange som bruker nav.no nå, derfor kan det ta litt tid før søknaden
    din kommer fram.
  </Alertstripe>
  <br />
  <Alertstripe type="feil" form="inline" mdxType="Alertstripe">
    Det er ikke mulig å sende søknaden akkurat nå, vennligst prøv igjen senere.
    Du er velkommen til å <Lenke href="#" mdxType="Lenke">følge med på hvordan det går</Lenke>.
  </Alertstripe>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<Alertstripe type="info" form="inline">
  Nå kan du sende inn søknaden.
</Alertstripe>
<br />
<Alertstripe type="suksess" form="inline">Du har sendt søknaden.</Alertstripe>
<br />
<Alertstripe type="advarsel" form="inline">
  Det er mange som bruker nav.no nå, derfor kan det ta litt tid før søknaden din
  kommer fram.
</Alertstripe>
<br />
<Alertstripe type="feil" form="inline">
  Det er ikke mulig å sende søknaden akkurat nå, vennligst prøv igjen senere. Du
  er velkommen til å <Lenke href="#">følge med på hvordan det går</Lenke>.
</Alertstripe>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      